import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Plus, Minus } from 'lucide-react';
const faqs = [{
  question: '¿El material sirve para mi país?',
  answer: 'Sí. Los contenidos incluyen los principales ejes de Física de educación secundaria y pueden adaptarse al programa educativo de distintos países de Latinoamérica. La denominación de los cursos puede variar según cada sistema educativo, pero los contenidos científicos fundamentales son equivalentes.'
}, {
  question: '¿En qué moneda se realiza el pago?',
  answer: 'El precio está expresado en dólares estadounidenses. Si utilizas otra moneda, el checkout mostrará o procesará automáticamente la conversión correspondiente, según tu país y el medio de pago disponible.'
}, {
  question: '¿Cómo recibiré el material?',
  answer: 'Después de confirmar el pago, recibirás un correo electrónico con las instrucciones para acceder y descargar los archivos.'
}, {
  question: '¿Puedo usarlo en clases particulares o talleres?',
  answer: 'Sí. Puedes utilizarlo en instituciones educativas, clases particulares, tutorías y talleres. La compra no autoriza su reventa, publicación ni distribución masiva.'
}, {
  question: '¿Tiene garantía?',
  answer: 'Sí. La compra incluye una garantía de satisfacción de 7 días.'
}];
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="py-8 md:py-20 px-4 bg-sky-200/30" data-id="element-59">
      <div className="max-w-3xl mx-auto" data-id="element-60">
        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-3xl md:text-5xl font-black text-center text-slate-900 mb-6 md:mb-16" data-id="element-61">
          Preguntas Frecuentes
        </motion.h2>

        <div className="space-y-3" data-id="element-62">
          {faqs.map((faq, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="bg-white rounded-2xl border border-blue-100 overflow-hidden shadow-sm" data-id="element-63">
              <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="w-full p-5 md:p-6 text-left flex justify-between items-center gap-4" data-id="element-64">
                <span className="font-black text-slate-900 text-sm md:text-lg leading-tight" data-id="element-65">
                  {faq.question}
                </span>
                <div className="shrink-0 text-blue-600" data-id="element-66">
                  {openIndex === index ? <Minus size={20} data-id="element-67" /> : <Plus size={20} data-id="element-68" />}
                </div>
              </button>

              <AnimatePresence data-id="element-69">
                {openIndex === index && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3,
              ease: 'easeInOut'
            }} data-id="element-70">
                    <div className="px-5 md:px-6 pb-6 text-slate-600 font-medium text-xs md:text-base leading-relaxed" data-id="element-71">
                      {faq.answer}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </motion.div>)}
        </div>
      </div>
    </section>;
}